import { render } from "./InformationInsert.vue?vue&type=template&id=1b9a576c&scoped=true"
import script from "./InformationInsert.vue?vue&type=script&lang=js"
export * from "./InformationInsert.vue?vue&type=script&lang=js"

import "./InformationInsert.vue?vue&type=style&index=0&id=1b9a576c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9a576c"]])

export default __exports__